import { HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { LightboxModule } from 'primeng/lightbox';
import { AppLayout } from './app.layout';
import { DashboardContent } from './dashboard/dashboard.content';
import { DashboardHeader } from './dashboard/dashboard.header';
import { AccountHttpService } from './generated/account-http.service';
import { LoginContent } from './login/login.content';
import { LoginHeader } from './login/login.header';
import { PasswordContent } from './password/password.content';
import { PasswordHeader } from './password/password.header';
import { RecoverContent } from './recover/recover.content';
import { RecoverHeader } from './recover/recover.header';
import { ReportService } from './report/service';
import { ResetContent } from './reset/reset.content';
import { ResetHeader } from './reset/reset.header';
import { AuthGuard } from './shared/auth.guard';
import { CustomErrorHandler } from './shared/CustomErrorHandler';
import { SharedService } from './shared/service';
import { SharedModule } from './shared/shared.module';


export const routes: Routes = [
  {
    path: 'login', children: [
      { path: '', component: LoginHeader, outlet: 'header' },
      { path: '', component: LoginContent }
    ]
  },
  {
    path: 'recover', children: [
      { path: '', component: RecoverHeader, outlet: 'header' },
      { path: '', component: RecoverContent }
    ]
  },
  {
    path: 'reset', children: [
      { path: '', component: ResetHeader, outlet: 'header' },
      { path: '', component: ResetContent }
    ]
  },
  {
    path: 'password', canActivate: [AuthGuard], children: [
      { path: '', component: PasswordHeader, outlet: 'header' },
      { path: '', component: PasswordContent }
    ]
  },
  {
    path: 'packaging', canActivate: [AuthGuard], loadChildren: () => import('./report/report.module').then(m => m.ReportModule)
  },
  {
    path: 'project', canActivate: [AuthGuard], loadChildren: () => import('./project/project.module').then(m => m.ProjectModule)
  },
  {
    path: 'admin', canActivate: [AuthGuard], data: { roles: ['Admin'] }, loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
  },
  {
    path: 'consultant', canActivate: [AuthGuard], data: { roles: ['Admin', 'Consultant']  }, loadChildren: () => import('./consultant/consultant.module').then(m => m.ConsultantModule)
  },
  {
    path: '', canActivate: [AuthGuard], children: [
      { path: '', component: DashboardHeader, outlet: 'header' },
      { path: '', component: DashboardContent }
    ]
  }
];

@NgModule({
  providers: [
    SharedService,
    ReportService,
    MessageService,
    AccountHttpService,
    ConfirmationService,
    { provide: ErrorHandler, useClass: CustomErrorHandler }
  ],
  declarations: [
    AppLayout,
    LoginHeader,
    LoginContent,
    DashboardHeader,
    DashboardContent,
    PasswordHeader,
    PasswordContent,
    RecoverHeader,
    RecoverContent,
    ResetHeader,
    ResetContent
  ],
  imports: [
    SharedModule.forRoot(),
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }),
    ReactiveFormsModule,
    HttpClientModule,
    ConfirmDialogModule,
    LightboxModule,
    FormsModule
  ],
  bootstrap: [AppLayout]
})
export class AppModule { }
